import { createAction } from 'redux-actions';
import { change } from 'redux-form';
import { map } from 'lodash';
import { batchActions } from 'redux-batched-actions';
import {
  ARTICLE_DETAIL_FETCH,
  ARTICLE_DETAIL_SUCCESS,
  ARTICLE_DETAIL_FAILURE
} from './actionTypes';
import api from '../../services/api';
import { ARTICLE_FORM_NAME } from '../ArticleForm/constants';

//<<<---ARTICLE-DETAIL--->>>
export const articleDetailFetch = createAction(ARTICLE_DETAIL_FETCH);
export const articleDetailSuccess = createAction(ARTICLE_DETAIL_SUCCESS);
export const articleDetailFailure = createAction(ARTICLE_DETAIL_FAILURE);

export const fetchArticleDetail = (id, lang) => async dispatch => {
  dispatch(articleDetailFetch());
  try {
    const { data } = await api.get(`article/${id}/${lang}`);

    const { showOnHomepage, headerImageLarge } = data;

    const fieldNames = [
      'title',
      'description',
      'header',
      'headerImageSmall',
      'image',
      'slug',
      'subtitle',
      'content'
    ];

    const fieldChangeActions = map(fieldNames, fieldName =>
      change(ARTICLE_FORM_NAME, fieldName, data[fieldName])
    );
    fieldChangeActions.push(
      change(ARTICLE_FORM_NAME, 'headerImageLarge', {
        src: `https://api.alfadent.ikiguys.net${headerImageLarge}`
      })
    );

    fieldChangeActions.push(
      change(
        ARTICLE_FORM_NAME,
        'showOnHomepage',
        showOnHomepage && showOnHomepage === 'true'
      )
    );

    dispatch(batchActions(fieldChangeActions));
    dispatch(articleDetailSuccess());
  } catch (error) {
    dispatch(articleDetailFailure(error));
  }
};



// WEBPACK FOOTER //
// ./src/modules/ArticleDetail/actions.js